import React from 'react';
import Layout from '../../components/layout';
import SectionHeroImage from '../../components/shared/SectionHeroImage';
import FeatureSection from '../../components/shared/FeatureSection';
import { useStaticQuery, graphql } from 'gatsby';
import { useImages } from '../../hooks';
import DeerIcon from '../../assets/svg/deer.svg';
import SEO from '../../components/seo';

const HuntingPage = ({ pageContext: { locale } }) => {
	const imageQuery = useStaticQuery(
		graphql`
			query {
				gallery: allFile(
					filter: {
						extension: { regex: "/(jpg)|(jpeg)|(png)/" }
						sourceInstanceName: { eq: "GalleryImages" }
						relativeDirectory: { eq: "tegevused/jahindus" }
					}
				) {
					edges {
						node {
							childImageSharp {
								fluid(maxWidth: 6000, maxHeight: 6000, quality: 75) {
									originalName
									...GatsbyImageSharpFluid
								}
							}
						}
					}
				}
				hero: file(
					extension: { regex: "/(jpg)|(jpeg)|(png)/" }
					sourceInstanceName: { eq: "GalleryImages" }
					relativeDirectory: { eq: "tegevused/jahindus" }
					name: { in: "hero" }
				) {
					childImageSharp {
						fluid(quality: 75) {
							originalName
							...GatsbyImageSharpFluid
						}
					}
				}
			}
		`
	);

	const [images, heroImage] = useImages(imageQuery);

	return (
		<Layout locale={locale}>
			<SEO title='jahindus' />
			<div className='hunting'>
				{heroImage && (
					<SectionHeroImage
						image={heroImage}
						sizeClass='is-large'
						titleTranslationKey='tegevused.jahindus.pealkiri'
					/>
				)}
				<FeatureSection
					icon={DeerIcon}
					hasHeroImage={!!heroImage}
					images={images}
					contentTranslationKey='tegevused.jahindus.blokk1'
				/>
			</div>
		</Layout>
	);
};

export default HuntingPage;
